import Modal from "~/components/ui/modal";

import styles from "./cannotBookPopup.module.scss";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const CannotBookPopup = ({ open, setOpen }: Props) => {
  const handleCloseModal = () => {
    setOpen(false);
  };
  return (
    <Modal open={open} onClose={handleCloseModal}>
      <div className={styles.container}>
        <p className={styles.text}>
          Vous avez atteint le nombre maximal des événements qu’il vous est
          possible de réserver en simultané. Cette règle permet de garantir que
          tous les membres puissent profiter des événements culturels.
        </p>
      </div>
    </Modal>
  );
};

export default CannotBookPopup;
